import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMail, FiPhone, FiMapPin, FiHeart, FiTwitter, FiFacebook, FiInstagram, FiShield} = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-patriot-navy text-white relative overflow-hidden">
      {/* Patriotic Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M30 30l15-15v30l-15-15zm-15 0l15 15v-30l-15 15z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}
        ></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-patriot-red rounded-md flex items-center justify-center shadow-md">
                <SafeIcon icon={FiShield} className="text-white h-6 w-6" />
              </div>
              <div>
                <span className="text-2xl font-bold font-display">The GOP Zone</span>
                <div className="text-patriot-gold text-sm font-medium">Republican Platform</div>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md leading-relaxed">
              Building the future of Republican engagement through constitutional education, community building, and conservative action. Join thousands of patriots working to preserve American values and strengthen our constitutional republic.
            </p>
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-2xl">🇺🇸</span>
              <span className="text-patriot-gold font-medium">Proudly Republican • Proudly American</span>
            </div>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-700 rounded-md flex items-center justify-center text-gray-300 hover:text-white hover:bg-patriot-red transition-all duration-300"
                aria-label="Email us"
              >
                <SafeIcon icon={FiMail} className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-700 rounded-md flex items-center justify-center text-gray-300 hover:text-white hover:bg-patriot-red transition-all duration-300"
                aria-label="Call us"
              >
                <SafeIcon icon={FiPhone} className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-700 rounded-md flex items-center justify-center text-gray-300 hover:text-white hover:bg-patriot-red transition-all duration-300"
                aria-label="Follow us on Twitter"
              >
                <SafeIcon icon={FiTwitter} className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-700 rounded-md flex items-center justify-center text-gray-300 hover:text-white hover:bg-patriot-red transition-all duration-300"
                aria-label="Follow us on Facebook"
              >
                <SafeIcon icon={FiFacebook} className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Republican Platform */}
          <div>
            <h3 className="text-lg font-semibold mb-6 font-display text-patriot-gold">Republican Platform</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/learning"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Constitutional Learning
                </Link>
              </li>
              <li>
                <Link
                  to="/events"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Republican Events
                </Link>
              </li>
              <li>
                <Link
                  to="/candidates"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  GOP Candidates
                </Link>
              </li>
              <li>
                <Link
                  to="/community"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Republican Community
                </Link>
              </li>
            </ul>
          </div>

          {/* Support & Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-6 font-display text-patriot-gold">Support & Resources</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Constitution Center
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Republican Resources
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Contact Support
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-patriot-gold transition-colors duration-200 flex items-center"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 flex items-center">
              © 2024 The GOP Zone Republican Platform. All rights reserved. Built with{' '}
              <SafeIcon icon={FiHeart} className="inline h-4 w-4 text-patriot-red mx-1" aria-label="love" />
              {' '}for the United States of America.
            </p>
            <div className="mt-4 md:mt-0 flex items-center space-x-4">
              <span className="text-sm text-patriot-gold font-medium">🦅 Defending the Constitution</span>
              <span className="text-sm text-gray-400">•</span>
              <span className="text-sm text-patriot-gold font-medium">Made in USA 🇺🇸</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;